export default {
  default: () => import("/app/layouts/default.vue").then(m => m.default || m),
  preview: () => import("/app/layouts/preview.vue").then(m => m.default || m)
}